export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	
	show_: state => {
		const { show } = state.popupParams;
		return show;
	},
	
	searchParams_: ({ cmpnMstPopup }) => cmpnMstPopup
};
